import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "toggle-wrapper" }
const _hoisted_2 = { class: "text" }
const _hoisted_3 = { class: "label" }
const _hoisted_4 = { class: "description" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Toggle = _resolveComponent("Toggle")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Toggle, {
      modelValue: _ctx.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((_ctx.value) = $event))
    }, null, 8 /* PROPS */, ["modelValue"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString($props.label), 1 /* TEXT */),
      _createElementVNode("div", _hoisted_4, _toDisplayString($props.description), 1 /* TEXT */)
    ])
  ]))
}